import { useCallback } from 'react';
import { Creator } from '~/clientApi/creator.model';
import { EditCreatorModal } from '~/screens/MyAgency';
import { useEditCreatorStore } from '~/screens/MyAgency/store';
import { ICreator } from '~/types';

import { CountriesDistributionWidget } from './CountryDistributionWidget';

export function ImageWithAddLocationButton({ creator }: { creator?: Creator }) {
  const { openEditModal } = useEditCreatorStore();

  const handleClick = useCallback(() => {
    if (!creator) return;

    openEditModal(creator as ICreator);
  }, [creator, openEditModal]);

  return (
    <>
      <EditCreatorModal />
      <CountriesDistributionWidget
        title="Countries distribution"
        description="Please specify Talent location in order to view audience location estimates."
        button={{
          children: 'Add Location',
          onClick: handleClick,
        }}
      />
    </>
  );
}
